import { Link } from 'react-router-dom';
import React, { useState, useContext } from 'react';
//import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { UserContext } from './UserContext';
import logo from '../assets/logo.png';
import '../assets/Login.css';


function ResetPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  
  const verifierMotDePasse = (password) => {
	  const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}$/;
	  return regex.test(password);
	};

   const handleChangePassword = () => {
    if (newPassword !== confirmNewPassword) {
      setMessage('Les mots de passe ne correspondent pas.');
      setMessageType('danger');
      return;
    }
	if (!verifierMotDePasse(newPassword)) {
			setMessage('Le mot de passe doit être valide. Au moins une majuscule, un caratère spécial et un chiffre');
			setMessageType('danger');
			return;
		  }
  if (!verifierMotDePasse(confirmNewPassword)) {
	setMessage('Le mot de passe doit être valide. Au moins une majuscule, un caratère spécial et un chiffre');
	setMessageType('danger');
	return;
  }
    // Envoyer nouvelle password
    fetch('https://ekapi.bblconcept.com/updateUserProfile.php?infos=mdpreset', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, newPassword: newPassword}),
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setMessage('Mot de passe mis à jour. Connectez-vous à votre boite mail pour activer le compte');
        setMessageType('success');
        setNewPassword('');
        setConfirmNewPassword('');
     
      } else {
        setMessage(data.error || 'Erreur lors de la modification');
        setMessageType('danger');
      }
    })
    .catch(error => {
		  console.error('Erreur lors de la requête:', error);
		  setMessage('Une erreur est survenue, veuillez réessayer plus tard. Ou, vérifier votre adresse mail.');
		  setMessageType('danger');
		});
  };

  return (
    <div className="login-container">
      <div className="login-top"></div>
      <div className="login-form-container">
        <div className="card p-4 shadow">
		
          <div className="text-center">
		  <img src="logo2.jpg" alt="Logo" style={{ maxWidth: '200px'}} className="mb-4" />
			  
				<p className="mb-4 text-secondary" style={{ fontSize: '14px' }}>Ici Slogan</p>
				
		{/* <img src={logo} alt="Logo" style={{ maxWidth: '200px'}} className="mb-4" />*/}
          </div>
          <h2 className="text-center mb-4 mt-4">Réinitialiser son mot de passe</h2>
       
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Email"
                value={email}
				autocomplete="username"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Nouveau mot de passe</label>
				  <input
					type="password"
					className="form-control"
					value={newPassword}
					autocomplete="new-password"
					onChange={(e) => setNewPassword(e.target.value)}
				  />
            </div>
			 <div className="mb-3">
             <label className="form-label">Confirmer le mot de passe</label>
			  <input
				type="password"
				className="form-control"
				value={confirmNewPassword}
				autocomplete="new-password"
				onChange={(e) => setConfirmNewPassword(e.target.value)}
			  />
            </div>
            <button className="btn btn-primary me-2" onClick={handleChangePassword}>
			  Enregistrer
			</button>
       
		  <div className="d-flex justify-content-between mt-3">
			  <Link to="/login" className="text-decoration-none">Se connecter</Link>
			  <Link to="/Register" className="text-decoration-none">Créer un compte</Link>
		 </div>
          {message && (
            <div className="mt-3">
              <p className={`text-center alert alert-${messageType}`}>{message}</p>
            </div>
          )}
        </div>
      </div>
	  
      <div className="login-bottom"></div>
	   <p className="text-center" style={{ fontSize: '12px' }}>
	  © {new Date().getFullYear()} Empreinte Kapital - by BLConcept
	</p>
    </div>
	
  );
}

export default ResetPassword;
